import React from "react";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormCheck } from "go-form";
import { FormSelectGroup } from "go-form/components/FormSelect";
import { AppStateApi, ApplicationApi } from "../../../../../../../../../services/Api/Organization/types";

interface Props {
	form: UseFormReturn<ApplicationApi>;
	appState: AppStateApi;
}

const DocumentTransferSendingDataForm = ({ form, appState }: Props) => {
	const { t } = useTranslation();
	const {
		formState: { errors },
		register,
		control,
	} = form;

	const orderExportCostTypeOptions = [
		{
			value: "SALE_PRICE",
			label: t("enums.apps.product_export_price_type.SALE_PRICE"),
		},
		{
			value: "REFERENCE_PRICE",
			label: t("enums.apps.product_export_price_type.REFERENCE_PRICE"),
		},
		{
			value: "LAST_PRICE",
			label: t("enums.apps.product_export_price_type.LAST_PRICE"),
		},
		{
			value: "FIFO_COST",
			label: t("enums.apps.product_export_price_type.FIFO_COST"),
		},
		{
			value: "DISABLED",
			label: t("enums.apps.product_export_price_type.DISABLED"),
		},
	];

	return (
		<>
			<h5>{t("modules.app.field.sending_data.title")}</h5>
			<fieldset>
				<div className="row mb-3">
					<div className="col-md-6">
						<FormSelectGroup
							errors={errors}
							label={t("modules.app.field.order_export_cost_type.title")}
							help={t("modules.app.field.order_export_cost_type.help_text")}
							control={control}
							name="settings.ORDER_EXPORT_PRICE_TYPE"
							options={orderExportCostTypeOptions}
							defaultValue={{
								id: appState.app.settings.ORDER_EXPORT_PRICE_TYPE,
								label: t(
									`enums.apps.export_cost_type.${appState.app.settings.ORDER_EXPORT_PRICE_TYPE}`
								),
							}}
							data-testid="settings.ORDER_EXPORT_PRICE_TYPE"
						/>
					</div>
					<div className="col-md-6 form-check-container">
						<FormCheck
							errors={errors}
							register={register}
							type="switch"
							name="settings.EXPORT_ORDERS"
							label={t("modules.app.field.export_orders.title")}
							help={t("modules.app.field.export_orders.help_text")}
						/>
					</div>
				</div>
			</fieldset>
		</>
	);
};

export default DocumentTransferSendingDataForm;
